import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiRequest } from '@/lib/http/http-api';

/** Reload after switching cookies so neither router nor query cache retains another actor's data. */
const useIdentitySwitch = (destination: string) => {
  const client = useQueryClient();
  return async () => {
    await client.cancelQueries();
    client.clear();
    window.location.assign(destination);
  };
};

export const useImpersonateUser = () => {
  const switched = useIdentitySwitch('/profile');
  return useMutation({
    mutationFn: (id: string) =>
      apiRequest<{ success: boolean }>(`/api/admin/users/${id}/impersonate`, {
        method: 'POST',
      }),
    onSuccess: switched,
  });
};

export const useStopImpersonating = () => {
  const switched = useIdentitySwitch('/system/users');
  return useMutation({
    mutationFn: () =>
      apiRequest<{ success: boolean }>('/api/admin/users/stop-impersonating', {
        method: 'POST',
      }),
    onSuccess: switched,
  });
};
